var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExportModal',{ref:"exportModal",attrs:{"title":"Faturas Pagas","loading":_vm.exportLoading},on:{"submit:export":_vm.submitExport}})
}
var staticRenderFns = []

export { render, staticRenderFns }